import React from 'react';
import './PriceCard.scss';
import PropTypes from 'prop-types';
import Bed from '../../../images/faq/bed.png';
import OldMan from '../../../images/faq/old_man.png';
import FollowUp from '../../../images/faq/follow_up.png';

export default function PriceCard(props) {
  const {
    title,
    price,
  } = props;

  function iconPriceCard() {
    let icon = null;
    switch (title) {
      case 'New Patient Visit':
        icon = OldMan;
        break;
      case 'Follow-up Visit':
        icon = FollowUp;
        break;
      default:
        icon = Bed;
    }
    return icon;
  }

  return (
    <div className="price-card">
      <img src={iconPriceCard(title)} alt={title} />
      <div className="price-card__description">
        <p className="price-card__title">{title}</p>
        <p className="price-card__price">{price}</p>
      </div>
    </div>
  );
}

PriceCard.defaultProps = {
  title: null,
  price: null,
};

PriceCard.propTypes = {
  title: PropTypes.string,
  price: PropTypes.string,
};
